import { v4 as uuidv4 } from "uuid";

export const rawBlocks = [
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/5d620023-6dee-49a0-40f8-f375695b3001/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/aaa90071-33dd-476c-e4a4-0b70a430d001/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/e7a39cd9-930d-4e5c-cb48-d65b2e719f01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/fdc60b8a-18df-42de-102e-9dd66e46be01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/2b2be79a-452c-497f-1cc2-8f6fb6831b01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/71f06f3f-6917-4b47-1735-6151a0ecdb01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/0b00bb69-1b39-4fa1-68b7-b506bcd3a501/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/ef54cba5-8944-4b1d-24f0-6426dca68401/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/64441424-293c-4421-6585-8d7748347501/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/73513918-d663-40b7-5902-42e51e8ce201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/f8c51939-6efa-4ba0-e69a-f0dd98c3df01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/a157463a-ba3d-41bf-4e54-6b0392979301/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/5a201c5a-524a-4d45-e942-4d19d2f9f101/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/51cd9a33-7a4d-4415-a5eb-296d804da701/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/ea5268dd-e7ae-4719-f630-61d9c0aace01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/a22b313e-c68e-4955-c501-058a14738301/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/73f5cbed-3acd-48b1-5f83-ad27f7e8f201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/4053eafe-7c42-474a-fe06-db3fa92fa901/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/085aaa05-1bda-418d-70d6-70b259ae3b01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/e0de1be1-f0bd-48df-884f-5a1c8bffe301/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/0a9cba63-f8e9-4982-5cff-1d503b175201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/51efc42d-e2da-41d2-f72e-f9be820c3801/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/e1026f36-3cb5-4041-3a3f-aafde1050701/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/a15e87d6-a3ba-4f0c-9878-49f76e7f2801/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/e2c65934-88bf-4b1c-c14b-b2c23d3ef201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/283f879c-f17a-459b-a42c-c9db078b7701/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/10285056-ba88-46c0-f411-b13f2dde0901/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/e6e0f800-485e-49f5-2fba-401519e1e201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/6a3a8319-c0ea-4540-ccc6-804a32deec01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/7c890b96-b4f8-423b-0222-6d10a6da4a01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/72760b4d-ca1a-44c2-a83f-8b25d66dd601/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/f4038fce-e80d-43c1-2472-ccf5da4a9e01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/7347f42b-338a-4036-d5c3-d0bab04e5101/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/1039425f-d06e-4253-ec12-953f9ee76801/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/adc140e1-e299-4be9-9e43-de65f0f10501/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/8c80223c-d499-46c2-bbbd-e760bcfb8f01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/56535c74-a9b6-4ee4-f7a1-680378425901/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/16cd628f-1a5b-4a68-0535-7fda13ff2301/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/646df9a3-c336-4ae8-869f-ae46a9a8fb01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/eeb584a2-369f-4e05-2b19-30e4264efc01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/ac8c16eb-6925-439e-3d5b-e2c2fd0ec801/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/6eed1baa-67c7-4533-4ea1-972f8443e201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/594ec0c9-40b6-453b-75b6-595a5ebd2101/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/64b42152-fc2b-4d3b-4c70-ac6821255101/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/2e170212-42f8-4bdb-c5e2-cb71b57f8a01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/e0af33e3-d4a4-4b1e-625d-cafa24f5a401/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/1d60abe8-77a5-4c0b-7821-329151b7ae01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/097be953-1473-4e12-3425-5d11c5166e01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/13d6b164-48d2-43d6-a5ab-03a08652c701/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/a51120da-2e12-418a-9646-dbc9dadbca01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/0a6f8bf3-bad1-4737-d5f9-969e30309401/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/4888d01a-7af9-4486-0894-23639eb6ae01/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/765191a9-1ac3-4ae4-65e1-8e5b5790e201/public",
  },
  {
    type: "image",
    data: "	https://imagedelivery.net/_ErcMMrtk1pGQjEMyl4E3Q/47eac9f8-afa9-4674-135d-01b88cdb3001/public",
  },
];

export const getDefaultApplicationGuideContent = rawBlocks.map((block) => ({
  ...block,
  id: uuidv4(),
}));
